import { Image } from "@clipboard-health/ui-react";
import { IonButton, IonLabel } from "@ionic/react";
import { Alert, Box } from "@mui/material";
import { logEvent } from "@src/appV2/lib/analytics";
import { useMyShiftsMaxEarnings } from "@src/appV2/Shifts/MyShiftUnavailable";
import { ShiftLoader } from "@src/lib/deprecatedCode";
import moment from "moment-timezone";
import { useHistory } from "react-router-dom";

import { formatRate } from "./helper";
import { USER_EVENTS } from "../../constants/userEvents";

interface NoMyShiftsAvailableProps {
  /**
   * This prop is related to vertical placement of this component, but the placement
   * really should be managed by the caller.
   */
  unverifiedShiftsLength: number;
}

export function NoMyShiftsAvailable(props: NoMyShiftsAvailableProps) {
  const { unverifiedShiftsLength } = props;
  const history = useHistory();

  const { data: maxEarnings, isLoading, isError } = useMyShiftsMaxEarnings();

  if (isError) {
    return <Alert severity="error">Something went wrong while retrieving available shifts.</Alert>;
  }
  if (isLoading) {
    return <ShiftLoader loading={isLoading} count={1} />;
  }

  const { amount = 0, date } = maxEarnings ?? {};

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: unverifiedShiftsLength === 0 ? "center" : "",
        marginBottom: 0.5,
      }}
    >
      <Image width="160px" src="assets/logo/bunny.png" alt="Clipboard logo" />
      {amount === 0 ? (
        <IonLabel color="text" class="ion-padding ion-text-center">
          There are no available shifts nearby for you to book. <br />
          Expand your distance preferences in My Account or check back later when more shifts become
          available.
        </IonLabel>
      ) : (
        <>
          <IonLabel color="text" class="ion-padding ion-text-center">
            You haven’t booked any upcoming shifts!
            <br />
            Go to Find Shifts to start booking now
            <br />
            <IonLabel color="text" class="ion-padding ion-text-center">
              Earn up to <b>${formatRate(amount)}</b> per shift
              {moment().isSame(date, "day") && <b> today</b>}!
            </IonLabel>
          </IonLabel>
          <IonButton
            shape="round"
            class="primary-btn"
            onClick={() => {
              logEvent(USER_EVENTS.TAPPED_GO_TO_OPEN_SHIFTS);
              history.push("/home/openShifts");
            }}
          >
            Find Shifts
          </IonButton>
        </>
      )}
    </Box>
  );
}
